import { UpdateCartCounts } from './cart';
import { PostAsync } from '../Helpers/postAsync'

const ErrorClass = "error";
const SuccessClass = "success";
const OpenClass = "open";

//  todo
//  add autocomplete
//      each time we add an input, reinitialize autocomplete for all inputs
//      
import * as $ from "jquery";

export function initAutocomplete() {

    const AutocompleteSize = 5;

    let autocompleteContainers = document.querySelectorAll('[data-quick-order-part-container]');
    for (let i = 0; i < autocompleteContainers.length; i++) {
        initAutocomplete(autocompleteContainers[i]);
    }

    function initAutocomplete(containerEl) {
        let container = containerEl;
        let searchInput = container.querySelector('[data-quick-order-part]');
        let autocomplete = container.querySelector('[data-quick-order-autocomplete-container]');
        let autocompleteList = autocomplete.querySelector('ul');

        document.addEventListener("click", function (e) {
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.contains(e.target)) {
                inactivateAndEmpty();
            }
        })

        searchInput.addEventListener("keyup", function () {

            if (!searchInput.value) {
                inactivateAndEmpty();
            }

            var lastResults = $(this).data('results') || "";
            let isActive = '';
            let searchTerm = searchInput.value;

            if (searchTerm.length > 0) {
                isActive = 'active';
            }

            let autocompleteUrl = `/api/quickorder/getProductNameAutocomplete?term=${searchTerm}&size=${AutocompleteSize}`;

            $.getJSON(autocompleteUrl, function (data) {
                if (!data || data.length < 1) {
                    inactivateAndEmpty();
                    return;
                }

                if (data != lastResults) {
                    $(autocompleteList).empty();
                    $(searchInput).data('results', data);
                    [].forEach.call(data, function (value) {
                        $(autocomplete).addClass(isActive).find('ul').append('<li><a class="autocomplete-item quick-order-autocomplete" data-autocomplete-item href="">' + value.replace(/\+/g, ' ') + '</a></li>');
                    });
                    var autocompleteItems = autocomplete.querySelectorAll('[data-autocomplete-item]');
                    [].forEach.call(autocompleteItems, function (value) {
                        value.addEventListener("click", function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(autocomplete).removeClass('active');
                            searchInput.value = e.currentTarget.innerText;
                        });
                    });

                }

            });
        })

        function inactivateAndEmpty() {
            $(autocomplete).removeClass('active');
            $(autocompleteList).empty();
        }

        document.addEventListener("keydown", function (e) {
            if (container.contains(document.activeElement) && $(document.activeElement).hasClass("autocomplete-item") && e.keyCode == 40) {
                e.preventDefault();
                e.stopPropagation();
                var focusLi = $(autocomplete.querySelector('.autocomplete-item:focus'));
                if (focusLi.length == 0) {
                    let item = autocomplete.querySelector('.autocomplete-item');
                    item.focus();
                }
                else {
                    focusLi.parent().next().find('a').focus();
                }
                return false;
            }
        })

        document.addEventListener("keydown", function (e) {
            if (container.contains(document.activeElement) && $(document.activeElement).hasClass("autocomplete-item") && e.keyCode == 38) {
                e.preventDefault();
                e.stopPropagation();
                var focusLi = $(document.activeElement);
                var toFocus = focusLi.parent().prev().find('a');

                if (toFocus.length == 0) {
                    searchInput.focus();
                }
                else {
                    toFocus.focus();
                }
                return false;
            }
        })
    }
}


export function initializeQuickorder() {
    var trigger: HTMLButtonElement = document.querySelector("[data-quick-order-trigger]");
    var content: HTMLElement = document.querySelector("[data-quick-order-content]");

    if (!trigger || !content) return;

    let quantityContainer: HTMLElement = content.querySelector('[data-quantity-container]');
    initQuantityStepper(quantityContainer);
    initAutocomplete();

    var addRow = content.querySelector("[data-quick-order-add-row]");
    let inputs = content.querySelector('[data-quick-order-inputs]');

    trigger.addEventListener("click", e => {
        if (content.classList.contains(OpenClass)) {
            let inputList = content.querySelectorAll('[data-quick-order-inputs]');

            if (typeof inputList !== 'undefined') {
                for (let i = 1; i < inputList.length; i++) {
                    inputList.item(i).remove();
                }
            }

            (inputList[0].querySelector('[data-quick-order-part]') as HTMLInputElement).value = "";
            inputs = inputList.item(0);
            content.classList.remove(OpenClass);
        }
        else {
            content.classList.add(OpenClass);
        }
    });

    // close on outside click
    document.addEventListener("click", function (e) {
        if (e.target !== trigger && !content.contains(e.target as HTMLElement)) {
            if (content.classList.contains(OpenClass)) {
                let inputList = content.querySelectorAll('[data-quick-order-inputs]');

                if (typeof inputList !== 'undefined') {
                    for (let i = 1; i < inputList.length; i++) {
                        inputList.item(i).remove();
                    }
                }

                (inputList[0].querySelector('[data-quick-order-part]') as HTMLInputElement).value = "";
                inputs = inputList.item(0);
                content.classList.remove(OpenClass);
            }
        }
    })

    addRow.addEventListener("click", function (e) {

        // clone inputs
        let clonedInputs = inputs.cloneNode(true) as HTMLElement;

        let labelParents = clonedInputs.querySelectorAll('[data-label-parent]');
        [].forEach.call(labelParents, (parent: HTMLElement) => {
            let label = parent.querySelector('label');
            if (label) {
                parent.removeChild(label);
            }
        })

        let part: HTMLInputElement = clonedInputs.querySelector("[data-quick-order-part]");
        part.value = '';

        let quantity: HTMLInputElement = clonedInputs.querySelector("[data-quick-order-quantity]");
        quantity.value = '1';

        let quantityContainer: HTMLElement = clonedInputs.querySelector('[data-quantity-container]');
        initQuantityStepper(quantityContainer);

        // remove message classes
        var messageContainer = clonedInputs.querySelector("[data-quick-order-message-container]");
        messageContainer.classList.remove(SuccessClass);
        messageContainer.classList.remove(ErrorClass);
        // add inputs after first set of inputs
        inputs.insertAdjacentElement('afterend', clonedInputs);
        // set current inputs to the new set
        inputs = clonedInputs;

        initAutocomplete();
    });

    var submit = content.querySelector("[data-quick-order-submit]");

    submit.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // set hidden field with serialized json
        try {
            let allInputs = content.querySelectorAll("[data-quick-order-inputs]");
            let values = [];

            [].forEach.call(allInputs, function (input) {
                values.push(Object.freeze({
                    partNumber: input.querySelector("[data-quick-order-part]").value ? input.querySelector("[data-quick-order-part]").value : '',
                    quantity: input.querySelector("[data-quick-order-quantity]").value ? input.querySelector("[data-quick-order-quantity]").value : 0
                }));
            });

            submit.setAttribute('disabled', 'true');

            PostAsync(`/api/quickorder/order`, { items: values })
                .then(data => {
                    console.log(data);
                    UpdateCartCounts();
                    let _data = data.data;
                    for (var index = 0; index < allInputs.length; index++) {
                        if (_data[index]) {
                            var messageElement = allInputs[index].querySelector("[data-quick-order-part-message]") as HTMLElement;
                            var value = _data[index].Message;
                            messageElement.innerText = value;

                            var messageContainer = allInputs[index].querySelector("[data-quick-order-message-container]") as HTMLElement;

                            if (_data[index].Success === true) {
                                messageContainer.classList.remove(ErrorClass);
                                messageContainer.classList.add(SuccessClass);
                            }
                            else {
                                messageContainer.classList.remove(SuccessClass);
                                messageContainer.classList.add(ErrorClass);
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    submit.removeAttribute('disabled');
                    initAutocomplete();
                });
        }
        catch (ex) {
            console.log(ex);
        }
    });
}


function initQuantityStepper(container: HTMLElement) {
    if (!container) return;

    let quantity: HTMLInputElement = container.querySelector('[data-quick-order-quantity]');
    let decrement: HTMLButtonElement = container.querySelector('[data-quantity-decrement]');
    let increment: HTMLButtonElement = container.querySelector('[data-quantity-increment]');

    if (!quantity || !decrement || !increment) return;

    decrement.onclick = () => {
        quantity.stepDown();
    }

    increment.onclick = () => {
        quantity.stepUp();
    }
}